export const LIST_SORT_OPTIONS = {
    'pivot.order': 'List Order',
    name: 'Alphabetical',
    rating: 'Rating',
    popularity: 'Popularity',
    release_date: 'Release Date',
    runtime: 'Runtime',
    'pivot.created_at': 'Date Added',
};
